import { Language, LocalizedString } from '@shared/types'

export const FALLBACK_EXIT_URLS: LocalizedString = {
  [Language.Fi]: 'https://www.s-pankki.fi/fi/logout',
  [Language.Sv]: 'https://www.s-pankki.fi/sv/logout',
}
